import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GerenciarOcorrenciasService } from '@services/gerenciar-ocorrencias.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseFormService } from '@services/base-form.service';
import { Router } from '@angular/router';
import { CustomSelectOption } from 'src/app/components/select-one/custom-select-option';
import { UntypedFormBuilder, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { dateValidator } from 'src/app/validators/date-validator';
import { HeaderComponent } from '../../components/header/header.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SelectOneComponent } from '../../components/select-one/select-one.component';
import { MatFormField, MatLabel, MatPrefix, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepickerToggleIcon, MatDatepicker } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { IconCalendarComponent } from '../../components/icon-calendar/icon-calendar.component';
import { SomenteNumerosDirective } from '../../directives/somente-numeros.directive';
import { MatButton } from '@angular/material/button';
import { IconFilterComponent } from '../../components/icon-filter/icon-filter.component';
import { SemResultadosComponent } from '../../components/sem-resultados/sem-resultados.component';
import { PaginacaoComponent } from '../../components/paginacao/paginacao.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-gerenciar-ocorrencias',
    templateUrl: './gerenciar-ocorrencias.component.html',
    styleUrls: ['./gerenciar-ocorrencias.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, LoadingGenericoComponent, BotaoChatComponent, BreadcrumbComponent, FormsModule, ReactiveFormsModule, SelectOneComponent, MatFormField, MatLabel, MatPrefix, MatInput, DateMaskDirective, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatIcon, MatDatepickerToggleIcon, IconCalendarComponent, MatDatepicker, MatError, SomenteNumerosDirective, MatButton, IconFilterComponent, SemResultadosComponent, PaginacaoComponent, FooterComponent, NgxPaginationModule]
})
export class GerenciarOcorrenciasComponent extends BaseFormService implements OnInit, OnDestroy {

  public loadingGenerico: any = false;

  public tiposOcorrencias: CustomSelectOption[] = new Array();
  public situacoes: CustomSelectOption[] = new Array();
  public dataLimite: Date = new Date('2000-1-1');

  public paginationTotal: any;
  public totalRegistros: number;
  public resources: any[];

  public empresa: any = localStorage.idEmpresaLogada;
  public idTipoOcorrencia: number;
  public idSituacao: any;
  public idOcorrenciaPai: any;

  public destroyed$ = new Subject<void>();

  public formFiltro = this.formBuilder.group({

    idTipoOcorrencia: new UntypedFormControl(),
    idSituacao: new UntypedFormControl(),
    dataInicial: new UntypedFormControl(['', dateValidator()]),
    dataFinal: new UntypedFormControl(['', dateValidator()]),
    numero: new UntypedFormControl(),
  });


  constructor(
    private readonly router: Router,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly gerenciarOcorrenciasService: GerenciarOcorrenciasService
  ) {
    super();
  }

  ngOnInit(): void {

    this.setDefaultPagination();
    this.formFiltro.reset();
    this.carregarTiposOcorrencias();
    this.carregarSituacoes();
    this.getApiData();
  }

  public verificarFiltros(): boolean {

    return (this.formFiltro.value?.idTipoOcorrencia != null ||
            this.formFiltro.value?.idSituacao != null ||
            this.formFiltro.value?.dataInicial != null ||
            this.formFiltro.value?.dataFinal!= null ||
            this.formFiltro.value?.numero != null);
  }

  public limparFiltros() {

    this.idTipoOcorrencia = null;
    this.idSituacao = null;
    this.formFiltro.reset();
  }

  public carregarTiposOcorrencias() {

    this.loadingGenerico = true;
    this.gerenciarOcorrenciasService
      .getTipoOcorrencia()
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (success: any) => {
          if (success) {
            this.tiposOcorrencias = success?.response.map(t => {
              return {
                id: t.idTipoOcorrencia, label: t.descricaoTipoOcorrencia
              }});
          }
        },
        error: (error: any) => {throw new Error(error);},
        complete: () => { this.loadingGenerico = false; }
      });
  }

  public carregarSituacoes() {

    this.loadingGenerico = true;
    this.gerenciarOcorrenciasService
      .getSituacaoOcorrencia()
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (success: any) => {
          if (success) {

            this.situacoes = success?.response.map(s => {
              return {
                id: s.codigo, label: s.descricao
              }});
          }
        },
        error: (error) => { throw new Error(error)},
        complete: () => { this.loadingGenerico = false; }
      });
  }

  public onChangeTipoOcorrencia(idTipoOcorrencia: any) {

    this.idTipoOcorrencia = idTipoOcorrencia;
    this.formFiltro.value.idTipoOcorrencia = idTipoOcorrencia;
  }

  public onChangeSituacao(idSituacao: any) {

    this.idSituacao = idSituacao;
    this.formFiltro.value.idSituacao = idSituacao;
  }

  public verificarNumero() {

    this.formFiltro.get('numero').updateValueAndValidity();

    if(this.formFiltro.get('numero')?.value && this.formFiltro.get('numero')?.value.length < 3) {
      this.formFiltro.get('numero').setErrors({invalid: true, message: 'Necessário no min. 3 dígitos'});
    }
  }

  public verificarDatas() {
    this.formFiltro.get('dataInicial').updateValueAndValidity();
    this.formFiltro.get('dataFinal').updateValueAndValidity();

    const hoje = new Date();
    const dataD1: Date = new Date(new Date().setDate(hoje.getDate() + 1));
    const dataD2: Date = new Date(new Date().setDate(hoje.getDate() + 2));

    const dataInicial: Date = new Date(this.formFiltro.get('dataInicial')?.value);
    const dataFinal: Date = new Date(this.formFiltro.get('dataFinal')?.value);

    if (this.formFiltro.get('dataInicial')?.value) {
      if (dataInicial.getTime() < this.dataLimite.getTime() || dataInicial.getTime() > dataD1.getTime()) {
        this.formFiltro.get('dataInicial').setErrors({ invalid: true, message: 'Data inválida' });
      }
    }

    if (this.formFiltro.get('dataFinal')?.value) {
      if (dataFinal.getTime() < this.dataLimite.getTime() || dataFinal.getTime() > dataD2.getTime()) {
        this.formFiltro.get('dataFinal').setErrors({ invalid: true, message: 'Data inválida' });
      }
    }

    if (
      this.formFiltro.get('dataFinal')?.value &&
      this.formFiltro.get('dataInicial').value &&
      this.formFiltro.get('dataInicial').value?.getTime() > this.formFiltro.get('dataFinal')?.value?.getTime()
    ) {
      this.formFiltro.get('dataInicial').setErrors({ invalid: true, message: 'Data inicial maior do que a data final' });
      this.formFiltro.get('dataFinal').setErrors({ invalid: true, message: 'Data final menor do que a data inicial' });
    }
  }

  public novaOcorrencia() {

    this.router.navigate(['/nova-ocorrencia']);
  }

  public getApiData() {


    let paramsArray = this.getParamsFormatArray();
    let paramsUrl = this.getParamsUrl(paramsArray);
    this.loadingGenerico = true;

    this.gerenciarOcorrenciasService
      .getAllHistorico(paramsUrl)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (success: any) => {
          if(success.status === 'NOK') {
            this.resources = [];
          }
          else if (success.status === 'OK') {

            this.resources = success.response.ocorrencias;
            this.totalRegistros = success.response.pageInfo.totalRegistros;
            this.paginationTotal = success.response.pageInfo;
            if ( this.totalRegistros > 0 && this.resources.length == 0){
              this.setDefaultPagination();
              this.getApiData();
            } else {
              this.setPagination(success);
            }

          } else {
            this.resources = [];
            this.setDefaultPagination();
          }
        },
        error: (error) => { throw new Error(error)},
        complete: () => { this.loadingGenerico = false; }
      });
    }

    public getParamsFormatArray() {


      let arr = [];

      arr.push(
        { name: 'pagina', comparator: '=', value: this.pagination.currentPageApi },
        { name: 'qtdPorPagina', comparator: '=', value: this.pagination.pageSize },
        { name: 'idEmpresa', comparator: '=', value: this.empresa }
      );

      if (this.formFiltro.value.dataFinal) {
        arr.push({ name: 'dataEmissaoFim', comparator: '=', value: this.formFiltro.value.dataFinal.toLocaleDateString("pt-BR") });
      }

      if (this.formFiltro.value.dataInicial) {
        arr.push({ name: 'dataEmissaoInicio', comparator: '=', value: this.formFiltro.value.dataInicial.toLocaleDateString("pt-BR") });
      }


      if (this.formFiltro.value.dataInicial && !this.formFiltro.value.dataFinal) {
        arr.push({ name: 'dataEmissaoFim', comparator: '=', value: new Date().toLocaleDateString("pt-BR") });
      }

      if (this.formFiltro.value.dataFinal && !this.formFiltro.value.dataInicial) {
        arr.push({ name: 'dataEmissaoInicio', comparator: '=', value: this.dataLimite.toLocaleDateString("pt-BR") });
      }

      if (this.formFiltro.value.idSituacao) {
        arr.push({ name: 'flagSituacao', comparator: '=', value: this.formFiltro.value.idSituacao });
      }


      if (this.formFiltro.value.idTipoOcorrencia) {
        arr.push({ name: 'idTipoOcorrencia', comparator: '=', value: this.formFiltro.value.idTipoOcorrencia });
      }

      if (this.formFiltro.value.numero != null && this.formFiltro.value.numero > 0) {
        arr.push({ name: 'numero', comparator: '=', value: this.formFiltro.value.numero });
      }

     return arr;
  }

  buttonTableClick(idOcorrencia) {

    this.loadingGenerico = true;
    this.idOcorrenciaPai = idOcorrencia;
    this.router.navigate(['/detalhes-ocorrencia/', this.idOcorrenciaPai]);
    this.loadingGenerico = false;

  }

  setPagination(res) {

    this.pagination.totalPages = this.paginationTotal.totalPaginas;
    this.pagination.currentPageApi = this.paginationTotal.pagina;
    this.pagination.currentPagePaginator = this.paginationTotal.pagina + 1;
    this.pagination.pageSize = this.paginationTotal.tamanho;
    this.pagination.totalElements = this.paginationTotal.totalRegistros;

    if (res.response?.pageInfo.pagina == 0) {
      this.pagination.currentPageApi = res.response.pageInfo.pagina;
    }
  }

  public setDefaultPagination(){

    this.pagination = {
      rows: [],
      currentPageApi: 0,
      currentPagePaginator: 1,
      pageSize: 5,
      totalElements: 0,
      totalPages: 0,
      search: null
    };
  }

  ngOnDestroy(): void {

    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
